import {inject, Injectable} from '@angular/core';
import {ColDef} from "ag-grid-community";
import {DatePipe} from "@angular/common";
import {BroadcastNotificationScopePipe} from "../pipes/broadcast-notification-scope.pipe";
import {BroadcastNotificationPipe} from "../pipes/broadcast-notification.pipe";
import {BroadcastNotificationSettingsComponent} from "../components/cell-renderers/broadcast-notification-settings/broadcast-notification-settings.component";

@Injectable({
  providedIn: 'root'
})
export class BroadcastNotificationTables {

  private datePipe = inject(DatePipe);
  private scopePipe = inject(BroadcastNotificationScopePipe);
  private typePipe = inject(BroadcastNotificationPipe);

  public broadcastNotificationColDefs: ColDef[] = [
    {
      headerName: 'Title',
      field: 'Title',
      width: 200,
      resizable: true,
      sortable: true,
      valueFormatter: (params) => {
        const title = params.value || '';
        return title.length > 30 ? title.substring(0, 30) + '...' : title;
      }
    },
    {
      headerName: 'Message',
      field: 'Message',
      width: 300,
      resizable: true,
      sortable: true,
      valueFormatter: (params) => {
        const message = params.value || '';
        return message.length > 60 ? message.substring(0, 60) + '...' : message;
      }
    },
    {
      headerName: 'Scope',
      field: 'BroadcastNotificationScopeTypeId',
      width: 120,
      resizable: true,
      sortable: true,
      valueFormatter: (params) => {
        return this.scopePipe.transform(params.value);
      }
    },
    {
      headerName: 'Game ID',
      field: 'GameId',
      width: 200,
      resizable: true,
      sortable: true,
      valueFormatter: (params) => {
        return params.value || 'N/A';
      }
    },
    {
      headerName: 'Type',
      field: 'BroadcastNotificationTypeId',
      width: 130,
      resizable: true,
      sortable: true,
      valueFormatter: (params) => {
        return this.typePipe.transform(params.value);
      }
    },
    {
      headerName: 'Start Date',
      field: 'StartDate',
      width: 180,
      resizable: true,
      sortable: true,
      valueFormatter: (params) => {
        const convertedDate = this.datePipe.transform(params.value, 'MMM d, y hh:mm a', 'UTC');
        return convertedDate ? convertedDate : '';
      }
    },
    {
      headerName: 'End Date',
      field: 'EndDate',
      width: 180,
      resizable: true,
      sortable: true,
      valueFormatter: (params) => {
        const convertedDate = this.datePipe.transform(params.value, 'MMM d, y hh:mm a', 'UTC');
        return convertedDate ? convertedDate : '';
      }
    },
    {
      headerName: '',
      width: 150, minWidth: 50, maxWidth: 150,
      cellRenderer: BroadcastNotificationSettingsComponent
    }
  ];
}
